import http from "./httpService";

class AssetsApi {
  headers = {
    accept: "application/json, text/plain, */*",
    "content-type": "application/json",
  };

  async getAssetsOptions(
    sortType,
    searchTxt,
    pickupDate,
    returnDate,
    pickupTime,
    returnTime,
    availFlag,
    selAssetType,
    selLocation
  ) {
    let sortValue = sortType.sortType || '';
    let sortOrder = sortType.sortOrder || '';
    let assetTypeAry = '';
    selAssetType.forEach((assetType) => {
      assetTypeAry += `&assetTypeId=${assetType}`;
    });

    let locIds = [];
  	if (selLocation.value === '') {
  	} else {
      locIds = [selLocation.value];
      if(selLocation?.obj?.childIds){
      	locIds = [...[selLocation.value],...selLocation?.obj?.childIds];
	  }
  	}
    let locationAry = '';
    locIds.forEach((locationId) => {
      locationAry += `&locationId=${locationId}`;
    });

    return http.get(
      process.env.REACT_APP_BASE_URL +
        `api/asset/search/portal?pickupStr=${pickupDate}&returnStr=${returnDate}&pickupTime=${pickupTime}&returnTime=${returnTime}&sort=${sortValue}&sortOrder=${sortOrder}&searchFilter=${searchTxt}&filterAvailable=${availFlag}${assetTypeAry}${locationAry}`
    );
  }

  async checkAssetAvailable(
    assetID,
    pickupDate,
    returnDate,
    pickupTime,
    returnTime
  ) {
    return http.get(
      process.env.REACT_APP_BASE_URL +
        `api/asset/search/portal?pickupStr=${pickupDate}&returnStr=${returnDate}&pickupTime=${pickupTime}&returnTime=${returnTime}&assetId=${assetID}`
    );
  }

  async getAssetRate(assetId) {
    return http.get(
      process.env.REACT_APP_BASE_URL +
        `api/asset/${assetId}/rate`
    );
  }
  async getBookingFee(assetID, pickupDate, pickupTime, returnDate, returnTime) {
    const bookingFeeData = `?assetId=${assetID}&pickupDate=${pickupDate}&pickupTime=${pickupTime}&returnDate=${returnDate}&returnTime=${returnTime}`; //&surcharge=$Asset_Surcharge
    return http.get(process.env.REACT_APP_BASE_URL + `api/booking/bill/fee${bookingFeeData}`);
  }
  async getAssetDetail(assetId) {
    return http.get(
      process.env.REACT_APP_BASE_URL +
        `api/asset/${assetId}/detail`
    );
  }
  async getAssetTypes() {
    return http.get(process.env.REACT_APP_BASE_URL + `api/asset/type/list?internal=false`);
  }

  async getSimilarAsset(
    assetId,
    pickupDate,
    returnDate,
    radius,
    pageCount,
  ) {
    const url = `${process.env.REACT_APP_BASE_URL
    }/api/asset/list/similar?assetId=${assetId}&pickupStr=${pickupDate}&returnStr=${returnDate}&radius=${radius}&pageCount=${pageCount}`;

    return http.get(url);
  }
}



export const assetsApi = new AssetsApi();
